export default __webpack_public_path__ + "static/portfolio_gallery_27-305b1a6a2828ea7b7b3043463885035b.jpg";